import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CalendlyService } from 'src/app/services/calendly.service';
import { environment } from 'src/environments/environment';

interface ServicePreview {
  id: string;
  name: string;
  desc: string;
}

@Component({
  selector: 'app-home',
  imports: [RouterModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public calendlyUrl = environment.CALENDLY_URL;
  servicesPreview: ServicePreview[] = [
    {
      id: 'enterprise-cloud-migration',
      name: 'Enterprise Cloud Migration',
      desc: 'Accelerate digital transformation with predictable, automated, zero-downtime enterprise migrations.'
    },
    {
      id: 'automated-finops',
      name: 'Automated FinOps',
      desc: 'Unify multi-cloud governance and eliminate infrastructure waste with data-driven FinOps intelligence.'
    },
    {
      id: 'cloud-native-sase',
      name: 'Cloud-Native SASE',
      desc: 'Consolidate disconnected perimeter security into a single, cloud-agnostic, single-vendor network fabric.'
    },
    {
      id: 'platform-engineering',
      name: 'Platform Engineering',
      desc: 'Transition from unmanaged virtual machines to resilient, fully-managed cloud platform services.'
    },
    {
      id: 'document-intelligence',
      name: 'Document Intelligence',
      desc: 'Process unstructured documents instantly using Spatial Computer Vision and NLP. Automate massive data-entry pipelines with near-perfect accuracy.'
    }
  ];

  contactForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    company: new FormControl(''),
    message: new FormControl('', Validators.required)
  });

  isSubmitting = false;
  submitted = false;

  constructor(
    private router: Router,
    private calendly: CalendlyService
  ) { }

  ngOnInit(): void { }

  navigateTo(route: string): void {
    this.router.navigate([route]);
    this.scrollToTop();
  }

  navigateToService(serviceId: string): void {
    this.router.navigate(['/services', serviceId]);
    this.scrollToTop();
  }

  openCalendlyPopup() {
    return this.calendly.openPopup(this.calendlyUrl);
  }

  onSubmit(): void {
    if (!this.contactForm.valid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    setTimeout(() => {
      this.isSubmitting = false;
      this.submitted = true;
      this.contactForm.reset();
      setTimeout(() => {
        this.submitted = false;
      }, 5000);
    }, 1500);
  }

  scrollToTop(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

}
